'use client';

import type { ReactNode } from 'react';

import { useContext, createContext } from 'react';

/**
 * 지금 화면의 머리 값 — 서비스 레이아웃이 사이드바 목록과 주소로 한 번 정해 내려 준다
 * (`resolveNavHeading`). 공유 페이지·메뉴 밖 화면에서는 null 이다.
 */
export type PageHeadingValue = { section: string | null; title: string } | null;

const PageHeadingContext = createContext<PageHeadingValue>(null);

export function PageHeadingProvider({ value, children }: { value: PageHeadingValue; children: ReactNode }) {
  return <PageHeadingContext.Provider value={value}>{children}</PageHeadingContext.Provider>;
}

/** @returns 사이드바 기준 구역·메뉴 이름 — 레이아웃 밖이거나 맞는 메뉴가 없으면 null */
export function usePageHeading(): PageHeadingValue {
  return useContext(PageHeadingContext);
}
